import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/**
 * Creates an asset via the dedicated assets store (not the brandConfig
 * blob). Returns the created asset record.
 *
 * Response shape assumed as response.data.asset — same ApiGatewayFunction
 * convention confirmed for other calls (no .body nesting), not re-verified
 * against this specific endpoint yet.
 */
export async function createAsset(appConfig, { brandId, recipe, content }, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "create_asset",
    client_id: appConfig.clientId,
    brand_id: brandId,
    recipe,
    content,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  const asset = response?.data?.asset;
  if (!asset) {
    throw new Error("Asset creation failed");
  }
  return asset;
}